import React from 'react';
export function PCFilters({items,value,onChange,label}) {
  return <div className="pc-filter-tabs" role="group" aria-label={label}>{items.map(([id,text])=><button key={id} type="button" aria-pressed={value===id} onClick={()=>onChange(id)}>{text}</button>)}</div>;
}
export function PCPagination({page,total,onChange}) {
  const pages=Math.max(1,Math.ceil(total/10));
  return <div className="pagination"><button disabled={page<=1} onClick={()=>onChange(page-1)}>上一页</button><span>{page} / {pages}</span><button disabled={page>=pages} onClick={()=>onChange(page+1)}>下一页</button></div>;
}
